// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3n1lu","col":"styles_col__2G958","fulfillmentStatus":"styles_fulfillmentStatus__2pUyM","emailCol":"styles_emailCol__3M1Op"};